import React from "react";
import { HeaderWrapper } from "./styled";
import { useSelector } from 'react-redux';
import { titlize } from "../../../helperFunctions";
import { useParams } from 'react-router-dom';
import { Row, Col, Image } from "antd";
import "./index.css"

const HeaderCustomerDetails = () => {
    const display_name = useSelector((state) => state?.display_name);
    const merchant_logo = useSelector((state) => state?.merchant_logo);
    const { vendor_name } = useParams();

    return (
        <HeaderWrapper className="header-main-cust">
            <Row justify="center">
                <Col className="display_name">
                    <div className="header-details">
                        <span>
                            <Image className="header-img" src={merchant_logo} alt="" preview={false} />
                        </span>
                        <span>
                            <h1 className="header-title">{(display_name ? display_name : vendor_name)}</h1>
                        </span>
                    </div>
                </Col>
            </Row>
        </HeaderWrapper>
    );
};

export default HeaderCustomerDetails;
